/**
 * @generated SignedSource<<7e982dc82455f84a574ae0f1a6b17029>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type CountryCodeQuery$variables = {};
export type CountryCodeQuery$data = {
  readonly panelConfigurations: ReadonlyArray<{
    readonly countryDetails: {
      readonly alpha2: string;
      readonly alpha3: string;
      readonly phoneNumberPrefixes: ReadonlyArray<number>;
    };
  }>;
};
export type CountryCodeQuery = {
  response: CountryCodeQuery$data;
  variables: CountryCodeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "concreteType": "CountryDetails",
  "kind": "LinkedField",
  "name": "countryDetails",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "phoneNumberPrefixes",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "alpha2",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "alpha3",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CountryCodeQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PanelConfiguration",
        "kind": "LinkedField",
        "name": "panelConfigurations",
        "plural": true,
        "selections": [
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "CountryCodeQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PanelConfiguration",
        "kind": "LinkedField",
        "name": "panelConfigurations",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3b901f2640eddd89e7ad2880f1a48639",
    "id": null,
    "metadata": {},
    "name": "CountryCodeQuery",
    "operationKind": "query",
    "text": "query CountryCodeQuery {\n  panelConfigurations {\n    countryDetails {\n      phoneNumberPrefixes\n      alpha2\n      alpha3\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "0cd86446d8bd2846010101d1efaf8c8c";

export default node;
